// extracted by mini-css-extract-plugin
export default {"text-black":"text-black__0X2KU","tw-font-normal":"tw-font-normal__kjrEm","text-semi-bold":"text-semi-bold__4k7wU","text-bold":"text-bold__JlXFU"};